import { Input } from "@/components/ui/input/input";

const validateDecimalInput = (input: string, allowNegative = false) => {
  // Regular expression to match decimal numbers with up to two digits after the decimal point
  // Allows negative numbers if allowNegative is true
  const regex = allowNegative ? /^-?\d*\.?\d{0,2}$/ : /^\d*\.?\d{0,2}$/;

  return regex.test(input);
};

export const PriceInput = ({
  value,
  onChange,
  onBlur,
  allowNegative = false,
  ...props
}: React.ComponentProps<typeof Input> & {
  onChange: (value: number | string) => void;
  allowNegative?: boolean;
}) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    let val = event.target.value;

    // Remove leading zero when user starts typing (e.g., "0" + "5" becomes "5" not "05")
    if (val.length > 1 && val.startsWith("0") && val[1] !== ".") {
      val = val.substring(1);
    }

    // Handle negative zero case (e.g., "-0" + "5" becomes "-5" not "-05")
    if (
      allowNegative &&
      val.length > 2 &&
      val.startsWith("-0") &&
      val[2] !== "."
    ) {
      val = `-${val.substring(2)}`;
    }

    if (validateDecimalInput(val, allowNegative)) {
      onChange?.(val);
    }
  };

  return (
    <Input
      value={value}
      onChange={handleChange}
      onBlur={onBlur}
      maxLength={100}
      {...props}
    />
  );
};
